<router-outlet class="h-screen"></router-outlet>
<div class="append-container" #notificationContainer></div>

<!-- Provide Feedback Button -->
<!-- <button kendoButton class="feedback-button" (click)="openDialog()">Provide feedback</button> -->

<!-- Feedback Popup -->
<kendo-dialog *ngIf="isDialogVisible" (close)="closeDialog()" [minWidth]="250" [width]="750" [maxHeight]="700">
  <kendo-dialog-titlebar>
    Feedback
  </kendo-dialog-titlebar>
  <p>Your feedback is appreciated. Please contact the Service Desk at 718-935-5100, or log your issue via Support Hub
    at:
    <a href="https://supporthub.schools.nyc/" target="_blank" rel="noopener noreferrer">NYC Public Schools<span class="k-sr-only"> (opens in new tab)</span></a>
  </p>
  <p>Be sure to upload an image of your issue along with contact information and a description of the issue.
    Include data about your current environment, like the browser and page URL. This helps us understand your feedback
    better. Thank you.
  </p>
  <p>
    <a href="javascript:void(0)" role="button" (click)="toggleDetails($event)" (keydown.enter)="toggleDetails($event)">What is included in the data about my current environment?</a>
  </p>
  <div *ngIf="showDetails">
    <ul>
      <li>Location: {{ location }}</li>
      <li>Referrer: {{ referrer }}</li>
      <li>User-Agent: {{ userAgent }}</li>
      <li>Screen Resolution: {{ screenResolution }}</li>
    </ul>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDialog()">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>